// extracted by mini-css-extract-plugin
export default {"wrap":"pYwue","text":"S740h","icon":"mksLK"};